import React from 'react';
import DOMPurify from 'dompurify';
import { HtmlBlock as HtmlBlockType } from '../../../../types/report-builder';

interface Props {
  block: HtmlBlockType;
}

const HtmlBlock: React.FC<Props> = ({ block }) => {
  const sanitizedHtml = DOMPurify.sanitize(block.html);

  return (
    <div
      className="my-4 rounded-[24px] border border-border/70 bg-card p-5 text-foreground shadow-[var(--shadow-card)] prose prose-sm max-w-none"
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
};

export default HtmlBlock;
